module.exports = __webpack_public_path__ + "static/media/Allissue.e28843ce.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/Allissue.PNG
// module id = 1638
// module chunks = 1